import { Box, TableCell, TableRow, Typography, styled } from "@mui/material"

export const DrawerBox = styled(Box)({
  width: "600px",
  display: "flex",
  flexDirection: "column",
  position: "relative",
  top: "70px",
})

export const DrawerBoxHeading = styled(Box)({
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
})
export const EventLogBox = styled(Box)({
  width: "100%",
  height: "93px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "20px 40px",
})

export const EventLogSubBox = styled(Box)({
  flexGrow: "1",
  width: "200px",
  height: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "flex-start",
  flexDirection: "column",
})

export const EventLogTypo = styled(Typography)({
  color: "#707070",
  fontSize: "12px",
})

export const EventLogTypoText = styled(Typography)({
  color: "#000",
  fontSize: "16px",
  fontWeight: "bold",
  lineHeight: "40px",
})
export const ActiveIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19.929"
    height="19.929"
    viewBox="0 0 19.929 19.929"
  >
    <g
      id="Group_35287"
      data-name="Group 35287"
      transform="translate(-378.123 -6079)"
    >
      <g id="图层_x0020_1" transform="translate(378.123 6079)">
        <circle
          id="Ellipse_515"
          data-name="Ellipse 515"
          cx="9.965"
          cy="9.965"
          r="9.965"
          transform="translate(0 0)"
          fill="#3d76ef"
        />
      </g>
      <g
        id="Layer_2_00000140736130153921798300000016668462501025497243_"
        transform="translate(381.779 5974)"
      >
        <g id="trend_up" transform="translate(-0.006 112)">
          <path
            id="Path_12491"
            data-name="Path 12491"
            d="M.776,119.1a.781.781,0,0,1-.358-.086A.728.728,0,0,1,0,118.251a1.037,1.037,0,0,1,.244-.518c1.231-1.251,2.467-2.482,3.4-3.412a.818.818,0,0,1,.575-.254.856.856,0,0,1,.607.274l2.122,2.122,2.886-2.889-.291,0-1.169-.007a.753.753,0,0,1-.782-.777.786.786,0,0,1,.22-.565.771.771,0,0,1,.555-.22c.587,0,1.172,0,1.737,0l1.744,0a.735.735,0,0,1,.762.748c.007,1.2.007,2.391,0,3.528a.741.741,0,0,1-.78.745h-.01a.747.747,0,0,1-.77-.765c0-.35,0-.706,0-1.048v-.54a.378.378,0,0,0-.032.03q-1.465,1.469-2.928,2.943l-.407.407a1,1,0,0,1-.7.365.983.983,0,0,1-.683-.355l-2.082-2.087-.175.173c-.183.18-.353.35-.521.518l-.785.789c-.451.454-.918.925-1.379,1.386a.818.818,0,0,1-.592.266Z"
            transform="translate(0.006 -112)"
            fill="#fff"
          />
        </g>
      </g>
    </g>
  </svg>
)

export const WatchIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19.929"
    height="19.929"
    viewBox="0 0 19.929 19.929"
  >
    <g
      id="Group_35283"
      data-name="Group 35283"
      transform="translate(-376.771 -6101)"
    >
      <g id="Group_35291" data-name="Group 35291">
        <g id="图层_x0020_1" transform="translate(376.771 6101)">
          <circle
            id="Ellipse_515"
            data-name="Ellipse 515"
            cx="9.965"
            cy="9.965"
            r="9.965"
            transform="translate(0 0)"
            fill="#716be8"
          />
        </g>
        <g
          id="Group_35280"
          data-name="Group 35280"
          transform="translate(148.783 5986.221)"
        >
          <g
            id="Group_35271"
            data-name="Group 35271"
            transform="translate(236.169 118.779)"
          >
            <path
              id="Path_12482"
              data-name="Path 12482"
              d="M242.021,128.393l-3.762-2.821v-5.747a1.045,1.045,0,0,0-2.09,0v6.27a1.043,1.043,0,0,0,.418.836l4.18,3.135a1.045,1.045,0,0,0,1.254-1.672Z"
              transform="translate(-236.169 -118.779)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const AchivedIcon = () => (
  <svg
    id="图层_x0020_1"
    xmlns="http://www.w3.org/2000/svg"
    width="19.929"
    height="19.929"
    viewBox="0 0 19.929 19.929"
  >
    <circle
      id="Ellipse_515"
      data-name="Ellipse 515"
      cx="9.965"
      cy="9.965"
      r="9.965"
      transform="translate(0 0)"
      fill="#00ba00"
    />
    <path
      id="Path_12484"
      data-name="Path 12484"
      d="M3.981,9.1.686,5.57A1.2,1.2,0,0,1,2.442,3.929L4.984,6.65,9.008,2.89A1.205,1.205,0,0,1,9.121,2.8l1.892-1.768a1.2,1.2,0,0,1,1.641,1.756l-5.78,5.4-.006-.007-2,1.868L3.981,9.1Z"
      transform="translate(3.266 4.84)"
      fill="#fff"
      fill-rule="evenodd"
    />
  </svg>
)

export const MissedIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19.929"
    height="19.929"
    viewBox="0 0 19.929 19.929"
  >
    <g
      id="Group_35285"
      data-name="Group 35285"
      transform="translate(-376.771 -6168.009)"
    >
      <g id="图层_x0020_1" transform="translate(376.771 6168.009)">
        <circle
          id="Ellipse_515"
          data-name="Ellipse 515"
          cx="9.965"
          cy="9.965"
          r="9.965"
          transform="translate(0 0)"
          fill="#d95e59"
        />
      </g>
      <g id="sad_2_" data-name="sad (2)" transform="translate(373.54 6163.833)">
        <path
          id="Path_12488"
          data-name="Path 12488"
          d="M13.506,18.882A6.142,6.142,0,0,0,9.136,20.7a.977.977,0,1,0,1.381,1.381,4.213,4.213,0,0,1,5.977,0A.977.977,0,1,0,17.876,20.7a6.142,6.142,0,0,0-4.37-1.816Z"
          transform="translate(-0.31 -3.353)"
          fill="#fff"
        />
        <path
          id="Path_12489"
          data-name="Path 12489"
          d="M10.76,10.668a1.4,1.4,0,1,0-1.4,1.4A1.4,1.4,0,0,0,10.76,10.668Z"
          transform="translate(0 0)"
          fill="#fff"
        />
        <path
          id="Path_12490"
          data-name="Path 12490"
          d="M21.14,9.269a1.4,1.4,0,1,0,1.4,1.4A1.4,1.4,0,0,0,21.14,9.269Z"
          transform="translate(-4.109)"
          fill="#fff"
        />
      </g>
    </g>
  </svg>
)
